import React from 'react'
import Footer from '../components/common/Footer'
import Header from '../components/common/Header'
import ContactSection from '../components/contact/ContactSection'
import FeaturesSection from '../components/features/FeaturesSection'
import HeroSection from '../components/hero/HeroSection'
import SpecialEducationSection from '../components/audience/SpecialEducationSection'
import WorkflowStorySection from '../components/workflow/WorkflowStorySection'
import SEO from '../components/seo/SEO'

const HomePage: React.FC = () => {
  return (
    <>
      <SEO
        title="TherapyLink - Special Education Therapy Provider Matching"
        description="Connect special education students with qualified therapy providers. TherapyLink helps schools, NPAs, and therapy teams manage student service requests, provider outreach, and FERPA-aligned workflows."
        canonical="https://therapy-link.org/"
      />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <HeroSection />
          <SpecialEducationSection />
          <FeaturesSection />
          <WorkflowStorySection />
          {/* <CaseStudiesSection /> */}
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  )
}

export default HomePage
